import React from 'react';
import PropTypes from 'prop-types';
import { Col, Form, InputGroup, Button, ToggleButton, Row } from 'react-bootstrap';
import SoftBadge from 'components/common/SoftBadge';
import ImagenPerfil from 'components/common/ImagenPerfil';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

/**
 * Componente para mostrar y editar etapa y propuesta económica del lead
 */
const LeadStageAndBudget = ({ 
    cargandoModal,
    detallesLead,
    editarEtapaModal,
    setEditarEtapaModal,
    catEtapas,
    CambiarEtapa,
    editarPropuestaEconomica,
    setEditarPropuestaEconomica,
    Modal_PropuestaEconomica,
    setModal_PropuestaEconomica,
    Modal_Moneda,
    setModal_Moneda,
    actualizarPropuestaEconomica
}) => {
    return (
        <Col>
            {/* Etapa */}
            {cargandoModal ? (
                <div className="mb-2">
                    <Skeleton width={150} height={32} borderRadius={20} />
                </div>
            ) : editarEtapaModal ? (
                <InputGroup className="fs--1 align-items-center mb-0">
                    <Form.Select
                        size="sm"
                        aria-label="Default select"
                        value={detallesLead.idEtapa}
                        onChange={async (event) => CambiarEtapa(event)}
                    >
                        {catEtapas.map((etapa, index) => (
                            <option key={index} value={etapa.idEtapa}>
                                {etapa.vNombreEtapa}
                            </option>
                        ))}
                    </Form.Select>
                    <span
                        style={{ cursor: 'pointer', paddingLeft: 0, paddingTop: '1%' }}
                        onClick={() => setEditarEtapaModal(false)}
                        className="text-left ms-2"
                    >
                        ✕
                    </span>
                </InputGroup>
            ) : (
                <>
                    <span
                        style={{ cursor: 'pointer' }}
                        onClick={(event) => {
                            if (event.detail === 2) {
                                setEditarEtapaModal(true);
                            }
                        }}
                    >
                        <SoftBadge 
                            pill 
                            bg={
                                detallesLead.idEtapa == 1 ? "secondary" :
                                detallesLead.idEtapa == 2 ? "primary" :
                                detallesLead.idEtapa == 3 ? "warning" :
                                detallesLead.idEtapa == 4 ? "success" :
                                detallesLead.idEtapa == 5 ? "danger" :
                                detallesLead.idEtapa == 6 ? "warning" :
                                detallesLead.idEtapa == 7 ? "success" : "success"
                            }
                            className="mt-1"
                        >
                            <p className="mb-0 fs-1 p-1">
                                {detallesLead.vNombreEtapa}
                            </p>
                        </SoftBadge>
                    </span>
                    <span>
                        <img 
                            style={{ cursor: 'pointer' }} 
                            width={20} 
                            src="/img/editar20.png" 
                            onClick={() => setEditarEtapaModal(true)}
                            alt="Editar"
                        />
                    </span>
                </>
            )}

            {/* Propuesta Económica */}
            {cargandoModal ? (
                <>
                    <div className="mt-2 mb-2">
                        <Skeleton width={120} height={24} />
                    </div>
                    <div className="d-flex align-items-center gap-2 mt-2">
                        <Skeleton circle width={40} height={40} />
                        <div className="d-flex flex-column flex-grow-1">
                            <Skeleton width={120} height={16} />
                            <Skeleton width={200} height={12} />
                        </div>
                    </div>
                </>
            ) : (
                <>
                    {editarPropuestaEconomica ? (
                        <>
                            <InputGroup className="fs--1 mt-2 mb-2 justify-content-center align-item-center align-self-center">
                                <span className="input-group-text">$</span>
                                <Form.Control
                                    type="text"
                                    size="sm"
                                    defaultValue={Modal_PropuestaEconomica}
                                    disabled={cargandoModal}
                                    autoComplete="off"
                                    onChange={(event) => setModal_PropuestaEconomica(event.target.value)}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                            actualizarPropuestaEconomica();
                                        }
                                    }}
                                />
                                <Button
                                    variant="outline-secondary"
                                    size="sm"
                                    onClick={() => actualizarPropuestaEconomica()}
                                >
                                    <img src="/img/check25.png" width="20" alt="Confirmar" />
                                </Button>
                                <Button
                                    variant="outline-secondary"
                                    size="sm"
                                    onClick={() => setEditarPropuestaEconomica(false)}
                                >
                                    ✕
                                </Button>
                            </InputGroup>
                            <Row className="align-self-center align-items-center justify-content-center m-0 p-0">
                                <Col className="col-8">
                                    <ToggleButton
                                        className="m-1"
                                        type="radio"
                                        id="radio-1"
                                        variant={'outline-primary'}
                                        name="radio"
                                        value="USD"
                                        checked={Modal_Moneda === 'USD'}
                                        onChange={() => setModal_Moneda("USD")}
                                    >
                                        USD
                                    </ToggleButton>
                                    <ToggleButton
                                        className="m-1"
                                        type="radio"
                                        id="radio-2"
                                        variant={'outline-primary'}
                                        name="radio"
                                        value="MXN"
                                        checked={Modal_Moneda === 'MXN'}
                                        onChange={() => setModal_Moneda("MXN")}
                                    >
                                        MXN
                                    </ToggleButton>
                                </Col>
                            </Row>
                        </>
                    ) : (
                        <p className="fs-2 mt-2 mb-2">
                            {detallesLead.dPropuestaEconomica} {detallesLead.vMoneda}
                            <span>
                                <img 
                                    style={{ cursor: 'pointer' }} 
                                    width={20} 
                                    src="/img/editar20.png" 
                                    onClick={() => setEditarPropuestaEconomica(true)}
                                    alt="Editar"
                                />
                            </span>
                        </p>
                    )}

                    <div className="d-flex align-items-center gap-2 mt-2">
                        <ImagenPerfil idUsuario={detallesLead.idUsuario} />
                        <div className="d-flex flex-column">
                            <strong className="fs--1">{detallesLead.vNombreUsuario}</strong>
                            <p className="fs--2 text-700 mb-0">
                                {"Registro: " + new Date(detallesLead.dCreatedDate).toLocaleDateString('es-mx', { 
                                    weekday: 'short', 
                                    year: 'numeric', 
                                    month: 'short', 
                                    day: 'numeric' 
                                }) + " " + new Date(detallesLead.dCreatedDate).toLocaleTimeString('es-mx', { hour12: true })}
                            </p>
                        </div>
                    </div>
                </>
            )}
        </Col>
    );
};

LeadStageAndBudget.propTypes = {
    cargandoModal: PropTypes.bool.isRequired,
    detallesLead: PropTypes.shape({
        idLead: PropTypes.number,
        idEtapa: PropTypes.number,
        vNombreEtapa: PropTypes.string,
        dPropuestaEconomica: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        vMoneda: PropTypes.string,
        vNombreUsuario: PropTypes.string,
        idUsuario: PropTypes.number,
        dCreatedDate: PropTypes.string
    }).isRequired,
    editarEtapaModal: PropTypes.bool.isRequired,
    setEditarEtapaModal: PropTypes.func.isRequired,
    catEtapas: PropTypes.arrayOf(
        PropTypes.shape({
            idEtapa: PropTypes.number,
            vNombreEtapa: PropTypes.string
        })
    ).isRequired,
    CambiarEtapa: PropTypes.func.isRequired,
    editarPropuestaEconomica: PropTypes.bool.isRequired,
    setEditarPropuestaEconomica: PropTypes.func.isRequired,
    Modal_PropuestaEconomica: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    setModal_PropuestaEconomica: PropTypes.func.isRequired,
    Modal_Moneda: PropTypes.string.isRequired,
    setModal_Moneda: PropTypes.func.isRequired,
    actualizarPropuestaEconomica: PropTypes.func.isRequired
};

export default LeadStageAndBudget;
